export const SECTION_NAME_TEST_DRIVE_LIST = {
  LISTING_PAGE: 'listing page',
  FILTER: 'filter',
  SORT: 'urutkan',
};

export const BUTTON_NAME_TEST_DRIVE_LIST = {
  TEST_DRIVE: 'test drive',
  KISARAN_HARGA: 'kisaran harga',
  JENIS_BAHAN_BAKAR: 'jenis bahan bakar',
  JUMLAH_TEMPAT_DUDUK: 'jumlah tempat duduk',
  SEARCH: 'search',
  SORT: 'urutkan',
  RESET_FILTER: 'reset filter',
  LIHAT_SELENGKAPNYA: 'lihat selengkapnya',
  EXPAND_BUTTON: 'expand button',
  TERAPKAN_FILTER: 'terapkan filter',
};

export const PAGE_NAME_TEST_DRIVE = {
  TEST_DRIVE_LISTING_PAGE: 'test drive listing page',
};

export const TEST_DRIVE_BUTTON_NAME = {
  CABANG_YANG_DIPILIH: 'cabang yang dipilih',
  LANJUT_TANGGAL_DAN_WAKTU_YANG_DIPILIH: 'lanjut tanggal & waktu yang dipilih',
  UBAH_MOBIL: 'ubah mobil',
  PESAN: 'pesan',
  LIHAT_SELENGKAPNYA: 'lihat selengkapnya',
  EXPAND_BUTTON: 'expand button',
};
